import { render, staticRenderFns } from "./HeaderQR.vue?vue&type=template&id=09635eae&scoped=true&"
import script from "./HeaderQR.vue?vue&type=script&lang=js&"
export * from "./HeaderQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09635eae",
  null
  
)

export default component.exports